import DayButtons from './upload components/DayButtons';
import UploadArea from './upload components/UploadArea';
import InputArea from './upload components/InputArea';

const Upload = () => {

    return(
        <>
            <DayButtons/>
            <UploadArea/>
            <InputArea/>
        </>
    )
}

export default Upload